import { Icon } from "./Icon.tsx";

/** Theme toggle icon shown while in dark mode (click to switch to light). */
export function MoonIcon() {
  return (
    <Icon>
      <path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
    </Icon>
  );
}
